/**
 * Vendedor que atiende al cliente.
 *
 * Cada vendedor tiene su link: https://tienda/?v=codigo (el código sale de
 * Config_Usuarios en ChekList). Quien entra por ese link queda asignado a ese
 * vendedor durante DIAS_VIGENCIA, aunque vuelva luego sin el ?v=. Si entra por
 * la página normal, elige vendedor al completar el pedido.
 */

import { useSyncExternalStore } from 'react';

export type OrigenVendedor = 'link' | 'elegido';

export interface VendedorGuardado {
  codigo: string;
  origen: OrigenVendedor;
  ts: number;
}

const STORAGE_KEY = 'onfase_vendedor';
const DIAS_VIGENCIA = 30;

let actual: VendedorGuardado | null = leer();
const oyentes = new Set<() => void>();

function leer(): VendedorGuardado | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as VendedorGuardado;
    if (!v?.codigo || Date.now() - v.ts > DIAS_VIGENCIA * 86_400_000) return null;
    return v;
  } catch {
    return null;
  }
}

export function setVendedor(codigo: string, origen: OrigenVendedor): void {
  actual = { codigo: codigo.trim().toLowerCase(), origen, ts: Date.now() };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(actual));
  } catch {
    // Sin almacenamiento (modo privado): vale para esta visita
  }
  oyentes.forEach((fn) => fn());
}

/** Lee ?v=codigo de la URL de entrada. Se llama una vez al arrancar la app. */
export function capturarVendedorDeUrl(): void {
  const codigo = new URLSearchParams(window.location.search).get('v');
  if (codigo && /^[a-z0-9-]{1,60}$/i.test(codigo.trim())) setVendedor(codigo, 'link');
}

export function useVendedorGuardado(): VendedorGuardado | null {
  return useSyncExternalStore(
    (fn) => {
      oyentes.add(fn);
      return () => oyentes.delete(fn);
    },
    () => actual,
  );
}
